// extracted by mini-css-extract-plugin
export default {"font":"font__IUw_kQ"};